import {useSubscription} from '../../providers/subscription/useSubscription.ts'
import {useConnections} from '../../providers/connections/useConnections.ts'
import {Flex, Title} from '@mantine/core'
import {LimitedFeatureBadge} from '../../components/limitedFeatureBadge/LimitedFeatureBadge.tsx'
import {ConnectionsList} from './ConnectionsList.tsx'

export const ConnectionsScreen = () => {
  const {activeSubscriptionTier} = useSubscription()
  const {connections, loading: loadingConnections} = useConnections()

  const disabled = loadingConnections || activeSubscriptionTier.tier === 'none'

  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
          maxWidth: 800,
        }}
      >
        <Flex>
          <Title order={3}>Connections</Title>
          <Flex flex={1} justify={'end'}>
            <LimitedFeatureBadge
              max={activeSubscriptionTier.features.maxActiveConnections}
              current={connections.length}
              loading={loadingConnections}
            />
          </Flex>
        </Flex>
        <ConnectionsList disabled={disabled} />
      </div>
    </div>
  )
}
